<div class="p-6">
  <!-- Toast notifications -->
  <p-toast position="top-right"></p-toast>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>

  <!-- Header Section -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h1 class="text-heading-xl mb-2">
        {{ 'learnMore.title' | translate }}
      </h1>
      <p class="text-body-md text-secondary">
        {{ 'learnMore.subtitle' | translate }}
      </p>
    </div>
    @if (loading()) {
    <p-skeleton width="8rem" height="2.5rem" class="flex-shrink-0"></p-skeleton>
    } @else {
    <p-button [label]="'learnMore.addItem' | translate" icon="pi pi-plus" [disabled]="loading()"
      (onClick)="openAddLearnMoreDialog()" class="flex-shrink-0">
    </p-button>
    }
  </div>

  <!-- Loading State -->
  @if (loading()) {
  <app-loading-spinner size="4rem" message="Loading learning resources..." containerClass="py-16">
  </app-loading-spinner>
  } @else if (learnMoreItems.length === 0) {
  <!-- Empty State -->
  <div class="text-center py-12">
    <div class="text-muted mb-4">
      <i class="pi pi-book text-6xl"></i>
    </div>
    <h3 class="text-heading-md mb-2">
      {{ 'learnMore.noItems' | translate }}
    </h3>
    <p class="text-body-md text-secondary mb-6">
      {{ 'learnMore.noItemsDescription' | translate }}
    </p>
    @if (loading()) {
    <p-skeleton width="10rem" height="2.5rem"></p-skeleton>
    } @else {
    <p-button [label]="'learnMore.addFirstItem' | translate" icon="pi pi-plus" (onClick)="openAddLearnMoreDialog()">
    </p-button>
    }
  </div>
  } @else {
  <!-- Items Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (item of learnMoreItems; track item.id; let i = $index) {
    <app-learn-more-item [item]="item" [index]="i" [coverImageUrl]="getCoverImageUrl(item.coverImage)"
      (edit)="onEditItem($event)" (remove)="onRemoveItem($event)">
    </app-learn-more-item>
    }
  </div>
  }
</div>
